import type {
  CsvWidgetExportAdditionalParams,
  CsvWidgetExportSource
} from '@/features/DataHub/modules/Export/types/context.types';

type SourceBackedDataExportLike = {
  additionalParams?: CsvWidgetExportAdditionalParams;
  sourceSettings?: {
    source: CsvWidgetExportSource;
    from?: string | null;
    to?: string | null;
    tabName?: string;
  };
};

export const isSourceBackedDataExport = (
  value: SourceBackedDataExportLike | null | undefined
): boolean => Boolean(value?.additionalParams);
